<div class="full-height flex layout-row layout-align-start-center">

  <div class="layout-row layout-align-start-center"
       (mouseenter)="getTagsDescription()">
    <bz-tag *ngFor="let tag of viewTags; let last = last"
            [color]="backgroundColor || tag.color"
            [textColor]="color"
            [ngbTooltip]="isShowTagDescriptions ? tagsDescriptionTooltip : (tagsMap[tag.name] || tag.name)"
            [openDelay]="300"
            triggers="hover"
            container="body"
            [ngClass]="{'item-margin': !last}">
      {{ tagsMap[tag.name] || tag.name }}
    </bz-tag>

    <ng-template #tagsDescriptionTooltip>
      <div class="layout-column">
        <div *ngFor="let tag of tagsDescription; let last = last" class="layout-column">
          <div class="layout-row layout-align-start-start">
            <span class="margin-left-5 font-weight-600">{{ tagsMap[tag.name] || tag.name }}</span>
          </div>
          <div *ngIf="tag.description" class="layout-row layout-align-start-start margin-top-5 tag-description"
               style="max-width: 350px !important;white-space: normal !important;word-wrap: break-word !important;overflow: hidden !important;text-overflow: ellipsis !important;">
            <span class="margin-left-5" style="text-align:start">{{ tag.description }}</span>
          </div>
          <hr *ngIf="!last" class="main-divider">
        </div>
      </div>
    </ng-template>
  </div>


  <div *ngIf="!!extraTags.length" class="margin-left-5 br-caption-2" [ngbTooltip]="tooltip"
       container="body"
       [openDelay]="300" triggers="hover">
    +{{ extraTags.length }}
    <ng-template #tooltip>
      <div class="layout-column">
        <span *ngFor="let extraTag of extraTags">
          {{ tagsMap[extraTag] || extraTag }}
        </span>
      </div>
    </ng-template>
  </div>
</div>
